import { render, staticRenderFns } from "./AccettazionePrestazioniListComponent.vue?vue&type=template&id=ab3c6af6&scoped=true"
import script from "./AccettazionePrestazioniListComponent.vue?vue&type=script&lang=js"
export * from "./AccettazionePrestazioniListComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazionePrestazioniListComponent.vue?vue&type=style&index=0&id=ab3c6af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3c6af6",
  null
  
)

export default component.exports